import { Box, Drawer } from "@mui/material";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { AiOutlineMail } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/dashboard/header icon.svg";
import { checkEmailExist } from "../../services/authServices";
import style from "./login.module.css";
import LoginOTP from "./loginOTP";
import { T3_LOGO } from "../../constants";
import Header from "../../common/Header";

const Login = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [isLoginOTPDrawer, setIsLoginOTPDrawer] = useState(false);
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleConfirm = async ({ email }) => {
    try {
      setEmail(email);
      const obj = { email, host: "t3" };
      const request = await checkEmailExist(obj);
      const response = request.data;

      if (response?.status === 1) {
        setIsLoginOTPDrawer(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    localStorage.clear();
  }, []);

  return (
    <Box className={style.container}>
      <Drawer
        anchor="bottom"
        open={isLoginOTPDrawer}
        onClose={() => setIsLoginOTPDrawer(false)}
        PaperProps={{ elevation: 0, style: { backgroundColor: "transparent" } }}
      >
        <LoginOTP close={setIsLoginOTPDrawer} email={email} />
      </Drawer>

      <Box className={style.hero_container}>
        <img src={process.env.PUBLIC_URL + "/assets/images/login_bg_v1.png"} />
        {/* <img src={process.env.PUBLIC_URL + "/assets/images/login_bg.jpg"} /> */}
      </Box>

      <Box className={style.main_container}>
        {/* <Box className={style.header_container}>
          <h4>Login</h4>
          <Box>
            <img src={T3_LOGO} />
          </Box>
        </Box> */}

        <Header canGoBack={false} bgColor="transparent" header="Login" canRedirectToHome={false} />

        <Box className={style.login_container}>
          <form onSubmit={handleSubmit(handleConfirm)}>
            <Box className={style.box_container}>
              <h4>Email</h4>
              <Box className={style.mobile_content}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 5,
                    width: "100%",
                  }}
                >
                  <AiOutlineMail />
                  <input
                    type="email"
                    className={style.email}
                    autoComplete="off"
                    {...register("email", {
                      required: "Email Address is required!",
                      pattern: {
                        value: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i,
                        message: "Please enter a valid email address",
                      },
                    })}
                  />
                </div>
              </Box>
            </Box>
            {errors.email && (
              <p
                style={{ color: "red", fontSize: "0.85rem", marginTop: "4px" }}
              >
                {errors.email.message}
              </p>
            )}
            <br />
            <button
              type="submit"
              className={style.box_container_btn}
              style={{ backgroundColor: "#7f3f97" }}
            >
              Login
            </button>
          </form>

          <Box>
            <h4 className={style.description_section}>
              Please{" "}
              <span onClick={() => navigate("/registration")}>Register</span> if
              you are new here
            </h4>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Login;
